import { Vector2 } from "../../utils/geom/Vector";
import { R, lerp, distance } from "../../utils/utils";
import COLORS from "./Colors";

function getPositionAt(points, t) {
  var length = points.length - 1;
  var i0 = Math.floor(length * t);
  i0 = i0 < length - 1 ? i0 : length - 1;
  var i1 = Math.min(i0 + 1, length);
  var delta = 1 / length;
  var nt = (t - i0 * delta) / delta;
  return {
    x: lerp(nt, points[i0].x, points[i1].x),
    y: lerp(nt, points[i0].y, points[i1].y),
  };
}

function getPointAtDistance(points, t, dist) {
  var o = getPositionAt(points, t);
  t -= 0.00001;
  if (t < 0) t += 1;
  var p = getPositionAt(points, t);
  var d = distance(o, p);

  let max = 100;
  while (d < dist && max--) {
    t -= 0.0001;
    if (t < 0) t += 1;
    p = getPositionAt(points, t);
    d = distance(o, p);
  }
  return t;
}

function getPointAt(points, t) {
  return points[~~(t * points.length)];
}

let uid = 0;
export default class Train {
  constructor(length = 8, path = 0) {
    //init train
    this.color = COLORS.colorAt(uid++);
    this.origin = new Vector2(0, 0);
    this.points = [this.origin];
    this.path = path;
    this.speed = (1 / this.path.length) * (10 + R(15));
    //length between this.points
    this.lengths = [0];
    for (let i = 1; i < length; i++) {
      var p = new Vector2(this.points[i - 1].x + i, this.points[i - 1].y + i);
      this.points.push(p);
      this.lengths.push(i % 2 == 0 ? 4 : 32);
    }
  }

  update(ctx, shadow = false, train = false) {
    //stick to path
    ctx.save();

    if (shadow == true) {
      const y = this.path[0].y / ctx.canvas.height;
      // ctx.filter = "blur(" + ~~(y * 10) + "px )";
      ctx.translate(0, y * 40);
      ctx.strokeStyle = "#CCC"; //this.color;

      ctx.beginPath();
      this.path.forEach((p, i) => {
        ctx.lineTo(p.x, p.y);
      });
      ctx.lineWidth = 4;
      ctx.stroke();

      ctx.beginPath();
      ctx.lineWidth = 16;
      this.points.forEach((p, i, a) => {
        if (i == 0) return;
        ctx.moveTo(a[i - 1].x, a[i - 1].y);
        ctx.lineTo(p.x, p.y);
      });
      ctx.stroke();
    } else {
      ctx.strokeStyle = this.color;
      if (train === false) {
        ctx.beginPath();
        this.path.forEach((p, i) => {
          ctx.lineTo(p.x, p.y);
        });
        ctx.lineWidth = 4;
        ctx.stroke();
      } else {
        ctx.beginPath();
        this.points.forEach((p, i, a) => {
          if (i == 0) return;
          ctx.moveTo(a[i - 1].x, a[i - 1].y);
          ctx.lineTo(p.x, p.y);
        });
        ctx.lineWidth = 12;
        ctx.strokeStyle = "#555";
        ctx.stroke();

        ctx.lineWidth = 10;
        ctx.strokeStyle = this.color;

        ctx.beginPath();
        this.points.forEach((p, i, a) => {
          if (i == 0) return;
          ctx.moveTo(a[i - 1].x, a[i - 1].y - 2);
          ctx.lineTo(p.x, p.y - 2);
        });
        ctx.stroke();
      }
    }
    ctx.restore();
  }

  move(ctx) {
    //stick to path
    let time = this.time;
    this.points.forEach((p, i) => {
      time = getPointAtDistance(this.path, time, this.lengths[i]);
      var t = getPositionAt(this.path, time);
      p.x = t.x;
      p.y = t.y;

      //   ctx.beginPath();
      //   ctx.arc(p.x, p.y, 2, 0, Math.PI * 2);
      //   ctx.stroke();
    });
  }
}
